// src/components/auth/GoogleLoginButton.js
import React from 'react';
import { googleLogin } from '../../api/auth/authApi';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';


const GoogleLoginButton = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

const handleSuccess = async (response) => {
  try {
      const { credential } = response;
      //console.log('Google login response:', response);

      // Send the credential token to the backend for verification
      const apiResponse = await googleLogin({ credential });
      const { token, message } = apiResponse;

      login({ fullName: apiResponse.fullName, email: apiResponse.email }, token);
      alert(message);
      navigate('/dashboard', { state: { showPopup: true } });
  } catch (error) {
      alert('Google login failed. Please try again.');
      console.error('Error in Google login:', error);
  }
};

  const handleError = (error) => {
    alert('Google login was canceled or failed.');
    console.error('Google login error:', error);
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      useOneTap={true}
    />
  );
};

export default GoogleLoginButton;
